/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Hero_Command_CopiedInputs */

const en_directory_home_hero_command_copied = /** @type {(inputs: Directory_Home_Hero_Command_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Command copied`)
};

const zh_directory_home_hero_command_copied = /** @type {(inputs: Directory_Home_Hero_Command_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`命令已复制`)
};

/**
* | output |
* | --- |
* | "Command copied" |
*
* @param {Directory_Home_Hero_Command_CopiedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_hero_command_copied = /** @type {((inputs?: Directory_Home_Hero_Command_CopiedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Hero_Command_CopiedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_hero_command_copied(inputs)
	return zh_directory_home_hero_command_copied(inputs)
});
export { directory_home_hero_command_copied as "directory.home.hero.command_copied" }